import type {
  GetAiAuditByIdQuery,
  GetAiAuditByIdQueryVariables,
  GetAiAuditFilterOptionsQuery,
  GetAiAuditFilterOptionsQueryVariables,
  GetAiAuditsQuery,
  GetAiAuditsQueryVariables,
} from '#src/graphql/generated';
import type { TypedDocumentNode } from '@apollo/client';

import { gql } from '@apollo/client';

export const GET_AI_AUDITS: TypedDocumentNode<
  GetAiAuditsQuery,
  GetAiAuditsQueryVariables
> = gql`
  query GetAiAudits($limit: Int, $endpoint: String, $processorId: String) {
    aiAudits(limit: $limit, endpoint: $endpoint, processorId: $processorId) {
      id
      createdAt
      endpoint
      metadata
      processorId
      iteration
      maxIterations
      model
      instanceId
    }
  }
`;

export const GET_AI_AUDIT_FILTER_OPTIONS: TypedDocumentNode<
  GetAiAuditFilterOptionsQuery,
  GetAiAuditFilterOptionsQueryVariables
> = gql`
  query GetAiAuditFilterOptions {
    aiAuditFilterOptions {
      endpoints
      processorIds
    }
  }
`;

export const GET_AI_AUDIT_BY_ID: TypedDocumentNode<
  GetAiAuditByIdQuery,
  GetAiAuditByIdQueryVariables
> = gql`
  query GetAiAuditById($id: String!) {
    aiAudit(id: $id) {
      id
      createdAt
      endpoint
      metadata
      processorId
      iteration
      maxIterations
      model
      instanceId
      input
      output
    }
  }
`;
